<template>
  <div :class="$style.wrapper">
<!--    {{$mq}}-->
    <l-lesson2-layout
      @successKeys="(type) => handleSuccess(type)"
      @successGraph="(type) => handleSuccessGraph(type)"
      @errorGraph="(type) => handleErrorGraph(type)"
      @nextGraph="d => handleNextGraph(d)"
      @progress="(d) => handleProgress(d)"
      :pianoData="pianoData"
      :xyloData="xyloData"
      :notes="notes"
      :ready="stage === 5"
      :active="active"
      withMiddle
    />
    <l-popupMessage
      :items="messages"
      :task="task"
      @click="nextStage"
    />
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import { ref, reactive } from '@vue/composition-api'

import clone from 'lodash/cloneDeep'

import pianoSpectrogram from '@/assets/json/bad-guy_piano.json'
import xyloSpectrogram from '@/assets/json/bad-guy_xylo.json'

import notes from '@/assets/notes/bad-guy.json'

import { pushPopup, pushHint } from '@/utils/pushPopup'

import {
  arr1, arr2, arr3, arr4, arr5, hint, task1, task2, taskXylo,
} from './arrs'

const prepareSpect = s => ({
  ...clone(s),
  peaks: clone(s.peaks).map(p => ({
    ...p,
    selected: false,
  })),
})

export default {
  name: 'step1',
  setup(props, { emit }) {
    const stage = ref(0)
    const messages = ref([])

    const active = ref(false)

    const task = ref(task1)

    const pianoData = reactive({
      current: -1,
      disabled: true,
      success: false,
      disabledGraph: true,
      errors: 0,
      spectrogram: prepareSpect(pianoSpectrogram),
    })

    const xyloData = reactive({
      current: -1,
      disabled: false,
      success: false,
      disabledGraph: true,
      spectrogram: prepareSpect(xyloSpectrogram, true),
    })

    const nextStage = (val) => {
      messages.value = []

      if (val?.key === 'xylo') {
        active.value = true
        return
      }

      if (stage.value === 0) {
        pushPopup(arr1, messages.value)
      }

      if (stage.value === 1) {
        active.value = true
      }

      if (stage.value === 2) {
        pushPopup(arr2, messages.value)
      }

      if (stage.value === 3) {
        pushPopup(arr3, messages.value)
      }

      if (stage.value === 4) {
        pianoData.disabledGraph = false
        xyloData.disabledGraph = false
      }

      // if (stage.value === 5) {
      //   pushPopup(arr4, messages.value)
      //   task.value = task2
      // }
      if (stage.value === 5) {
        pianoData.disabled = false
      }

      // if (stage.value === 6) {
      //   pushPopup(arr5, messages.value)
      // }

      if (stage.value === 6) {
        emit('nextStep', 1)
      }

      // if (stage.value === 3) {
      //   pushPopup(arr3, messages.value)
      // }

      // if (stage.value === 4) {
      //   pushHint(hint, messages.value)
      // }
      //
      // if (stage.value === 5) {
      //   pushPopup(arr4, messages.value)
      // }

      // if (stage.value === 6) {
      //   emit('nextStep', 2)
      // }

      stage.value += 1
    }

    nextStage()

    const handleSuccess = (type) => {
      if (type === 'piano') {
        pianoData.disabled = true
      }
      if (type === 'xylo') {
        xyloData.disabled = true
        pushPopup([{ text: 'А теперь давай сыграем мелодию на фортепиано, но на этот раз для каждой ноты отметь на графике локальные пики.', buttonTitle: 'Сыграть' }], messages.value)
        task.value = [{ text: 'А теперь давай сыграем мелодию на фортепиано, но на этот раз для каждой ноты отметь на графике локальные пики.' }]
      }
    }

    const handleNextGraph = ({ type, index }) => {
      if (type === 'piano') {
        pianoData.spectrogram.peaks[index].selected = true

        if (pianoData.current === pianoData.spectrogram.onset_frames.length - 1) {
          pianoData.success = true
        }
      }
      if (type === 'xylo') {
        xyloData.spectrogram.peaks[index].selected = true

        if (xyloData.current === xyloData.spectrogram.onset_frames.length - 1) {
          xyloData.success = true
        }
      }

      if (xyloData.success && pianoData.success) nextStage()
    }

    const handleSuccessGraph = (type) => {
      if (type === 'piano') {
        pianoData.disabled = false
        if (pianoData.current === 21) {
          messages.value = []
          pushPopup(arr5, messages.value)
        //   xyloData.disabled = false
        //   active.value = false
        //   pushPopup(taskXylo, messages.value)
        }
      }
      if (type === 'xylo') {
        xyloData.disabled = false
      }

      if (stage.value === 5) nextStage()
    }

    const handleSuccessSpect = (type) => {
      if (type === 'piano') pianoData.success = true
      if (type === 'xylo') xyloData.success = true
      if (pianoData.success && xyloData.success) nextStage()
    }

    const handleProgress = ({ type, p }) => {
      if (type === 'piano') {
        pianoData.current = p
        pianoData.disabled = true
        pianoData.errors = 0
      }
      if (type === 'xylo') {
        xyloData.current = p
        const currentFrame = xyloData.spectrogram.onset_frames[p]
        xyloData.spectrogram.peaks.forEach((peak) => {
          if (peak.peak_frame === currentFrame) {
            peak.selected = true
          }
        })
        // xyloData.disabled = true
      }

      if (stage.value === 2) nextStage()
    }

    const handleErrorGraph = (type) => {
      if (type === 'piano') {
        pianoData.errors += 1
        pushHint([{ text: 'Смотри внимательнее, это не локальный пик' }], messages.value)
        if (pianoData.errors === 3) {
          const currentFrame = pianoData.spectrogram.onset_frames[pianoData.current]
          pianoData.spectrogram.peaks.forEach((peak) => {
            if (peak.peak_frame === currentFrame) {
              peak.selected = true
            }
          })

          handleSuccessGraph(type)
        }
      }
    }

    return {
      notes,

      active,
      stage,
      messages,

      pianoData,
      xyloData,

      task,

      nextStage,
      handleSuccess,
      handleSuccessGraph,
      handleSuccessSpect,
      handleProgress,
      handleNextGraph,
      handleErrorGraph,
    }
  },
}
</script>
<style lang="scss" module>
.wrapper {
  background: linear-gradient(180deg, #4F4F4F 0%, #0A001E 100%);
  height: 100%;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  @media (max-width: $tabletWidth) {
    height: 100vh;
  }
}
.container {
  padding: 0 8rem;
  display: flex;
  height: 100%;

  & > div {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center
  }
}

.top {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
